/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: hooks/useUsersColumns.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Hook for generating users DataGrid columns.
────────────────────────────────────────────────────────────────*/

import { useMemo } from 'react';
import { useI18n } from '../../../hooks/useI18n';

export function useUsersColumns() {
  const { t, refreshKey, i18n } = useI18n();

  const availableColumns = useMemo(() => {
    return [
      { key: 'username', label: t('users.username'), visible: true, sortable: true },
      { key: 'email', label: t('users.email'), visible: true, sortable: true },
      { key: 'fullName', label: t('users.fullName'), visible: true, sortable: true },
      { key: 'department', label: t('common.department'), visible: true, sortable: true },
      { key: 'locale', label: t('common.language'), visible: true, sortable: true },
      { key: 'timezone', label: t('common.timezone'), visible: true, sortable: true },
      { key: 'totpEnabled', label: t('common.twoFA'), visible: true, sortable: true },
      { key: 'isActive', label: t('users.enabled'), visible: true, sortable: true },
      { key: 'profiles', label: t('common.profiles'), visible: true, sortable: false },
      { key: 'tenants', label: t('common.tenants'), visible: true, sortable: false },
      { key: 'created_at', label: t('users.created'), visible: true, sortable: true },
      { key: 'actions', label: t('users.actions'), visible: true, sortable: false },
    ];
  }, [t, i18n.language, refreshKey]);

  return availableColumns;
}

